import { includes, trim, uniq, values } from 'lodash-es';
import { QueryParamConfig, StringParam } from 'use-query-params';

import { ApplicationStatus } from '../../common/constants';
import { FilterApplicationSource } from './constants';

export const ALL_APPLICATION_STATUSES = 'ALL';

export const FilterApplicationSourcesQueryParam: QueryParamConfig<
  string[] | null | undefined,
  string[]
> = {
  encode: (array: string[] | null | undefined) =>
    array && array.length > 0
      ? uniq(array.map(trim).filter(Boolean)).join(',')
      : undefined,
  decode: (arrayStr: string | (string | null)[] | null | undefined) => {
    if (typeof arrayStr === 'string') {
      return uniq(arrayStr.split(',').map(trim).filter(Boolean));
    }
    return [];
  },
};

export const FilterApplicationSourceQueryParam: QueryParamConfig<
  FilterApplicationSource | null | undefined,
  FilterApplicationSource
> = {
  encode: StringParam.encode,
  decode: value => {
    const appSource = StringParam.decode(value);

    if (!appSource || !includes(values(FilterApplicationSource), appSource)) {
      return FilterApplicationSource.ALL_CANDIDATES;
    }

    return appSource as FilterApplicationSource;
  },
};

export const FilterApplicationStatusQueryParam: QueryParamConfig<
  string | null | undefined,
  string
> = {
  encode: StringParam.encode,
  decode: value => {
    const appStatus = StringParam.decode(value);

    if (
      !appStatus ||
      (appStatus !== ALL_APPLICATION_STATUSES &&
        !includes(values(ApplicationStatus), appStatus))
    ) {
      return ALL_APPLICATION_STATUSES;
    }

    return appStatus;
  },
};
